import { INavigationsElement } from '@gig/magic-sdk/dist/adapter/navigations/getNavigations';

/**
 * State of the navigation module. Contains all
 * state relating to navigation and routing.
 * @export
 * @interface INavigationState
 */
export interface INavigationsState {
    /**
     * The navigations items for the current
     * language and device.
     * @type {INavigationsElement[]}
     */
    navigations: INavigationsElement[];

    /**
     * The error received from the back end
     * when loading the navigations response.
     * @type {(string|null)}
     */
    navigationsError: string | null;
}

//Navigation Manager
export const NAVIGATIONS_NAMESPACE = 'navigations';

//Navigations
export const SET_NAVIGATIONS = 'SET_NAVIGATIONS';
export const SET_NAVIGATIONS_ERROR = 'SET_NAVIGATIONS_ERROR';
